import request from "../common";
import axios from "axios";
const HOST = "https://website.huoyunjh.com";
// const HOST = "http://news.huoyunjh.com";

// 获取新闻列表
export function getNewsList() {
  const url = HOST + "/huoduoduo/article";
  return axios.get(url);
}
// 获取新闻列表
export function getTypeNewsList(menuId, page) {
  const url =
    HOST + "/huoduoduo/article?size=8&menuId=" + menuId + "&current=" + page;
  return axios.get(url);
}

// 获取新闻详情
export function getNewsDetail(id) {
  const url = HOST + "/huoduoduo/article/" + id;
  return axios.get(url);
}

// 留言
export function leaveMessage(data) {
  return request({
    url: HOST + "/huoduoduo/message",
    method: "post",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js